<script setup>
import { computed } from 'vue';
import { marked } from 'marked';

const props = defineProps({
    content: {
        type: String,
        default: ''
    }
});

const formattedContent = computed(() => marked(props.content || '', { breaks: true }));
</script>

<template>
    <div class="md-text-preview" v-html="formattedContent"></div>
</template>

<style scoped>
.md-text-preview {
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #dddddd;
    min-height: 150px;
}
</style>